<template>
  <button
    class="flex items-center justify-between rounded-full bg-bgr border border-gray-400 hover:bg-thm-light transition focus:bg-thm-light h-11 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover disabled:bg-neutral-100 disabled:border-neutral-100 disabled:text-neutral-400"
  >
    <slot />
  </button>
</template>
